// extracted by mini-css-extract-plugin
export default {"wrap":"PageLoader_wrap__GP7N3"};